import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Dialog, DialogContent, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import axios from 'axios';
import { API_URL } from '../services/api';
import { getFullImageUrl } from '../config/imageConfig';

const Parrilla: React.FC = () => {
  const [scheduleImage, setScheduleImage] = useState<string>('');
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchScheduleImage();
  }, []);

  const fetchScheduleImage = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/settings/schedule_image`);

      if (response.data.success && response.data.setting) {
        setScheduleImage(response.data.setting.setting_value);
      } else {
        // Usar imagen por defecto si no hay configuración
        setScheduleImage('/parrilla/2025.jpeg');
      }
    } catch (error) {
      console.error('Error al cargar la imagen de la parrilla:', error);
      // Usar imagen por defecto en caso de error
      setScheduleImage('/parrilla/2025.jpeg');
    } finally {
      setLoading(false);
    }
  };

  const handleImageClick = () => {
    setImageDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setImageDialogOpen(false);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: '#FFFFFF',
            letterSpacing: '0.05em'
          }}
        >
          PARRILLA DE PROGRAMACIÓN 2025
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: 'rgba(255, 255, 255, 0.7)',
            fontWeight: 300
          }}
        >
          Toda nuestra programación semanal en un vistazo
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ position: 'relative' }}>
          <Box
            sx={{
              position: 'relative',
              cursor: 'pointer',
              borderRadius: 2,
              overflow: 'hidden',
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              border: '2px solid rgba(220, 20, 60, 0.2)',
              transition: 'all 0.3s',
              '&:hover': {
                transform: 'scale(1.02)',
                boxShadow: '0 10px 30px rgba(220, 20, 60, 0.3)',
                borderColor: 'rgba(220, 20, 60, 0.5)'
              },
              '&:hover .zoom-overlay': {
                opacity: 1
              }
            }}
            onClick={handleImageClick}
          >
            <img
              src={getFullImageUrl(scheduleImage)}
              alt="Parrilla de Programación 2025"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
            <Box
              className="zoom-overlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 0,
                transition: 'opacity 0.3s'
              }}
            >
              <ZoomInIcon sx={{ fontSize: 60, color: 'white' }} />
            </Box>
          </Box>

          <Typography
            variant="caption"
            sx={{
              display: 'block',
              textAlign: 'center',
              mt: 2,
              color: 'rgba(255, 255, 255, 0.5)'
            }}
          >
            Haz clic en la imagen para ampliar
          </Typography>
        </Box>
      )}

      {/* Dialog para imagen ampliada */}
      <Dialog
        open={imageDialogOpen}
        onClose={handleCloseDialog}
        maxWidth={false}
        PaperProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            maxWidth: '95vw',
            maxHeight: '95vh',
            margin: '20px'
          }
        }}
      >
        <DialogContent sx={{ p: 0, position: 'relative' }}>
          <IconButton
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={getFullImageUrl(scheduleImage)}
            alt="Parrilla de Programación 2025"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default Parrilla;